import { V3Models } from "@istari/istari-client";

import { SendingConnection } from "~/secure-connections/model/secure-connection";

import { toEditAccess } from "./to-edit-access";
import { toTagRuleSet } from "./to-tag-rule-set";

type SendingConnectionDto = V3Models.SendingConnectionDto;

export function toSendingConnection(dto: SendingConnectionDto): SendingConnection {
  return {
    kind: "sending",
    id: dto.id,
    label: dto.label,
    description: dto.description,
    sharedId: dto.sharedId,
    objectStoreId: dto.objectStoreId,
    tenantId: dto.tenantId,
    hasCrossTenantMembers: dto.hasCrossTenantMembers ?? null,
    isArchived: dto.isArchived,
    isStarred: dto.isStarred ?? false,
    created: dto.created,
    infosecLevelId: dto.infosecLevelId ?? null,
    editAccess: toEditAccess(dto.receivedAccessLevel),
    allowAllSenders: dto.allowAllSenders,
    allowReshare: dto.allowReshare,
    tagRules: toTagRuleSet(dto.tagRules),
  };
}
